// Shared helpers for the Manifold Tournaments pages.

export function statusClass(status) {
  switch (status) {
    case 'Active': return 'status-active';
    case 'Finished': return 'status-finished';
    case 'Coming Up':
    default: return 'status-coming-up';
  }
}

// Ṁ is Manifold's mana symbol.
export function formatMana(amount) {
  return `Ṁ${Number(amount).toLocaleString()}`;
}

export function totalPrizePool(prizes) {
  if (!prizes) return 0;
  return ['first', 'second', 'third'].reduce((sum, k) => sum + (Number(prizes[k]) || 0), 0);
}

const STATUS_ORDER = { Active: 0, 'Coming Up': 1, Finished: 2 };

export function compareTournaments(a, b) {
  const byStatus = (STATUS_ORDER[a.status] ?? 1) - (STATUS_ORDER[b.status] ?? 1);
  if (byStatus !== 0) return byStatus;
  return b.id - a.id; // newest first within a status
}

export const MEDALS = { 1: '🥇', 2: '🥈', 3: '🥉' };
